import { mutator } from 'satcheljs';
import { default as removeAccountById } from '../actions/removeAccountById';
import getAccountSourceListStore, { defaultStore } from '../store/accountSourceListStore';

export default mutator(removeAccountById, actionMessage => {
    const store = getAccountSourceListStore();
    store.sources = store.sources.filter(
        accountSource => accountSource.sourceId !== actionMessage.accountSourceId
    );

    if (actionMessage.accountSourceId == store.selectedSourceId) {
        // When removing the selected account update the selected sourceId
        store.selectedSourceId =
            store.sources.length > 0 ? store.sources[0].sourceId : defaultStore.selectedSourceId;
    }

    if (actionMessage.accountSourceId == store.globalSettingsSourceId) {
        // The current priority is providing the API for usage, so currently we make sure there
        // is an account for the API to use. When the me control is integrated it will be responsible
        // managing the  global setting account and this code will be updated. This is tracked by
        // Work Item 131822: Integrate the me control and account source list
        store.globalSettingsSourceId =
            store.sources.length > 0
                ? store.sources[0].sourceId
                : defaultStore.globalSettingsSourceId;
    }
});
